<template>
  <div class="taskList taskListStyle">
    <!-- 搜索 -->
    <div class="task-search" style="padding: 15rem 0px 4rem 0">
      <div class="search-fff">
        <el-form
          :inline="true"
          @submit.native.prevent
          :model="formInline"
          class="demo-form-inline"
        >
          <el-form-item label="Ip：">
            <el-input
              v-model="formInline.ip"
              class="formInput"
              placeholder="search for ip"
              @keyup.enter.native="seachEnter"
            ></el-input>
          </el-form-item>
          <el-form-item label="Country：">
            <el-input
              v-model="formInline.country"
              class="formInput"
              @keyup.enter.native="seachEnter"
              placeholder="search for country"
            ></el-input>
          </el-form-item>
          <el-form-item label="Time：">
            <el-date-picker
              v-model="timers"
              type="daterange"
              range-separator="to"
              start-placeholder="start time"
              end-placeholder="end time"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="changTime"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="Platform：">
            <el-select
              placeholder="platform"
              class="formInput"
              v-model="formInline.platform"
              @change="changes"
            >
              <el-option label="whole" value=""></el-option>
              <el-option label="arm" value="arm"></el-option>
              <el-option label="mips" value="mips"></el-option>
              <el-option label="mips64" value="mips64"></el-option>
              <el-option label="x86_64" value="x86_64"></el-option>
              <el-option label="aarch64" value="aarch64"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Status：">
            <el-select
              placeholder="Status"
              class="formInput"
              v-model="formInline.status"
              @change="changes"
            >
              <el-option label="whole" value=""></el-option>
              <el-option label="offline" value="0"></el-option>
              <el-option label="online" value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="searchClick()">search</el-button>
            <el-button @click="resetClick()">seset</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 表格 -->
    <div class="keshihua-table-three">
      <div class="taskList-table">
        <el-table :data="tableData" ref="multipleTable" tooltip-effect="dark">
          <el-table-column
            prop="ip"
            label="IP"
            show-overflow-tooltip
            align="center"
            :width="$globalProcessing.dateWidth(10)"
          ></el-table-column>
          <el-table-column
            prop="country"
            label="Country"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="os"
            label="OS"
            :width="$globalProcessing.dateWidth(15)"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="vender_model"
            label="Vendor_model"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="manager"
            label="Manager"
            show-overflow-tooltip
            :width="$globalProcessing.dateWidth(10)"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="platform"
            label="Platform"
            :width="$globalProcessing.dateWidth(10)"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            prop="first_time"
            label="First time"
            :width="$globalProcessing.dateWidth(10)"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="last_time"
            label="Last time"
            show-overflow-tooltip
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="status"
            label="Status"
            show-overflow-tooltip
            :width="$globalProcessing.dateWidth(10)"
            align="center"
          >
            <span slot-scope="scope">
              {{ scope.row.status == '0' ? 'offline' : 'online' }}
            </span>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="taskList-paging">
          <div class="pagination-fff">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pages.page"
              :page-sizes="[15]"
              :page-size="pages.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pages.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 接口文件

import { getTaskNode } from '@/api/task';
// 手动添加组件
export default {
  name: 'taskList',
  components: {},
  data: function () {
    return {
      formInline: {
        ip: '',
        country: '',
        platform: '',
        status: '',
        first_time: '',
        last_time: '',
      },
      timers: null,
      pages: {
        size: 15,
        page: 1,
        total: 0,
      },

      tableData: [],
    };
  },
  created() {},
  mounted() {
    this.gettaskListInfoFun();
  },
  computed: {
    title() {
      return this.$route.meta.title;
    },
  },
  methods: {
    seachEnter(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.gettaskListInfoFun();
      }
    },
    changes() {
      this.$forceUpdate();
    },
    changTime(val) {
      this.formInline.start_time = val[0];
      this.formInline.end_time = val[1];
    },

    newDialogFun() {
      this.gettaskListInfoFun();
    },

    // 表格请求接口
    gettaskListInfoFun() {
      // 深克隆数据
      let formInlineData = this.$globalProcessing.depthCopy(this.formInline);
      let pageData = this.$globalProcessing.depthCopy(this.pages);
      formInlineData.task_id = this.$route.query.id;
      // pageData.page = pageData.page - 1;
      getTaskNode({ ...pageData, ...formInlineData }).then((res) => {
        if (res.data.code == 200) {
          this.pages.total = res.data.data.total;
          this.tableData = res.data.data.data;
        } else {
          this.$globalProcessing.reportErrors.error(res.data.msg);
          this.tableData = [];
        }
      });
    },
    mapClick(val) {
      this.$router.push({
        path: '/taskListSituaTion',
        query: {
          id: val.id,
        },
      });
    },
    infoClick(val) {
      this.$router.push({
        path: '/taskListSituaTion',
        query: {
          id: val.id,
        },
      });
    },
    // 当前页
    handleCurrentChange(data) {
      this.pages.page = data;
      this.gettaskListInfoFun();
    },
    // 当前页条数
    handleSizeChange(data) {
      this.pages.page = 1;
      this.pages.size = data;
      this.gettaskListInfoFun();
    },
    // 搜素
    searchClick() {
      this.pages.page = 1;
      this.gettaskListInfoFun();
    },
    // 重置
    resetClick() {
      this.formInline = {};
      this.timers = null;
      this.formInline.status = '';
      this.formInline.platform = '';

      this.pages.page = 1;
      this.gettaskListInfoFun();
    },
    taskListCilck() {
      this.$refs.taskListRef.appLicModel = true;
      this.editId = {};
    },
    editClick(row) {
      this.editId = row;
      this.$refs.taskListRef.appLicModel = true;
    },

    // 删除
    delClick(val) {
      this.$confirm(
        'This operation will permanently delete this content. Do you want to continue?',
        'Tips',
        {
          confirmButtonText: 'determine',
          cancelButtonText: 'cancel',
          type: 'warning',
        },
      )
        .then(() => {
          getDelete(val.id).then((res) => {
            if (res.data.code == 200) {
              this.$globalProcessing.reportErrors.success(res.data.msg);
              this.gettaskListInfoFun();
            } else {
              this.$globalProcessing.reportErrors.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$globalProcessing.reportErrors.message('Deletion cancelled');
        });
    },
  },
};
</script>

<style scoped lang="less">
// tabs 切换颜色
/deep/.el-tabs__item {
  color: black;
  font-size: 16rem;
}
// form字体大小
/deep/.el-form-item .el-form-item__label {
  font-size: 15rem;
}
/deep/.el-table tr {
  height: 50px;
}
.search-fff {
  position: relative;
  .s1 {
    position: absolute;
    right: 4%;
    top: 0;
    padding: 9rem 20rem;
    color: #546afc;
    font-size: 16rem;
    border-radius: 10rem 10rem;
    background: #e8efff;
    cursor: pointer !important;
  }
  .s2 {
    position: absolute;
    right: 0;
    top: 16%;
    padding: 9rem 20rem;
    color: #546afc;
    border-radius: 10rem 10rem;
    background: #e8efff;
    cursor: pointer !important;
  }
}

.taskListStyle {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;

  .keshihua-table-three {
    flex: 1;
    position: relative;
    .taskList-table {
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      .red {
        color: #fe4e4e;
        background: #ffe6e7;
      }
      .blue {
        color: #546afc;
        background: #e8efff;
      }
      .btn-style {
        padding: 6rem 20rem;
        border-radius: 10rem 10rem;
        display: inline-block;
        cursor: pointer;
        margin: 0 5rem;
        // border-radius: 10%;
      }
    }
  }
}
</style>
